import { HolidayAdd, IHoliday } from 'src/types/master_data/holiday.type';
import { PagedList } from 'src/types/pagedList.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'master-data/holidays';

export const getHolidays = async (page: number, pageSize: number, orderBy?: string) => {
  return await http.get<PagedList<IHoliday>>(`${controller}/paging`, {
    params: {
      page,
      pageSize,
      orderBy
    }
  });
};

export const getHolidaysDropdown = async () => {
  return await http.get<IHoliday[]>(controller);
};

export const getHoliday = async (id: number) => {
  return await http.get<IHoliday>(`${controller}/${id}`);
};

export const addHoliday = async (holiday: HolidayAdd) => {
  return await http.post(controller, holiday);
};

export const updateHoliday = async (id: number, holiday: HolidayAdd) => {
  return await http.put(`${controller}/${id}`, holiday);
};

export const deleteHoliday = async (id: number) => {
  return await http.delete(`${controller}/${id}`);
};
